import React from 'react';

/**
 * AI 관리자 구역 전용 레이아웃 – 콘텐츠 영역
 */
const AIAdminLayout = ({ children }) => {
  return (
    <div className="w-full min-h-[calc(100vh-4rem)] bg-gray-50 font-sans text-gray-800 text-[15px]">
      {children}
    </div>
  );
};

export default AIAdminLayout;